import { OnInit, OnDestroy, Directive } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccountCenterService } from '../../../services/account-center/account-center.service';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { CoverpathUtils } from '../../../../js/static/CoverpathUtils';
import type { Policy } from '../../../../../common/js/customer/Policy';
import { Utils } from '../../../../../common/js/Utils';

@Directive()
export class AccountCenterSection implements OnInit, OnDestroy {
  hasInForcePolicy: boolean;
  hasCanceledPolicy: boolean;
  canCancel: boolean;
  workflowAction: string;
  allCanceled: boolean;
  utils: CoverpathUtils;
  accountCenterWorkflowSubscription: Subscription;

  constructor(protected amorphicService: AmorphicService, protected accountCenterService: AccountCenterService) {}

  isInForce() {
    return CoverpathUtils.isPolicyInForce(this.accountCenterService.primaryPolicy);
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    if (this.accountCenterWorkflowSubscription) {
      this.accountCenterWorkflowSubscription.unsubscribe();
    }
  }

  subscribeToAccountCenterService(): void {
    this.accountCenterWorkflowSubscription = this.accountCenterService.workflowStateSubject.subscribe(
      (workflowAction) => this.handleAction(workflowAction)
    );
  }

  handleAction(workflowAction: string): void {
    this.workflowAction = workflowAction;
    this.canCancel =
      CoverpathUtils.isInProcess(workflowAction) || this.accountCenterService.application.hasAnyInForce();
    this.allCanceled = this.accountCenterService.application.hasOnlyCanceled();

    if (this.accountCenterService.application.hasAnyInForce()) {
      this.hasInForcePolicy = true;
      this.hasCanceledPolicy = false;
    } else if (this.accountCenterService.application.hasOnlyCanceled()) {
      this.hasInForcePolicy = false;
      this.hasCanceledPolicy = true;
    } else {
      this.hasCanceledPolicy = false;
      this.hasInForcePolicy = false;
    }

    this.processWorkflowAction(workflowAction);
  }

  processWorkflowAction(workflowAction: string): void {}

  /**
   * @param {Policy} policy
   * @returns {string} representing the term + product type, e.g. Whole Life 100 or 20 Year Convertible Term
   */
  getPolicyDescription(policy: Policy): string {
    if (policy.isWholeLifePolicy()) {
      return `Whole Life ${policy.term}`;
    } else {
      return `${policy.term} Year Convertible Term`;
    }
  }

  formatFace(faceAmount: number | string): string {
    if (!faceAmount) {
      return '';
    }
    return Utils.formatIntCurrency(faceAmount + '');
  }
}
